module.exports = __webpack_public_path__ + "img/featured_challenge_ribbon.3dbbbe4d.svg";